import { ActivatedRouteSnapshot } from '@angular/router';
import { VueSessionCookieService } from '@vue/vueframework';
import { TestCenterService } from '../services/test-center.service';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TestCenterAffiliate } from '../types/test-center-affiliate.model';

@Injectable({
  providedIn: 'root'
})
export class SiteAffiliatesResolve {
  public constructor(
    private vueSessionCookieService: VueSessionCookieService,
    private testCenterService: TestCenterService
  ) { }

  public resolve(ignored: ActivatedRouteSnapshot): Observable<TestCenterAffiliate[]> {
    const realmDetail = JSON.parse(this.vueSessionCookieService.getAttribute('realmDetail', 'VUE'));
    const siteId = realmDetail.siteID;
    return this.testCenterService.getAffiliates(siteId, true)
      .pipe(
        map((response) => response),
        catchError(() => {
          return of(null);
        })
      );
  }
}
